import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import imagesLoaded from 'imagesloaded'

import { desktop, mobile } from './check-res.js'

// Register the GSAP plugins
gsap.registerPlugin(ScrollTrigger)

if (desktop) {
	const preloadImages = (selector = 'img') => {
		return new Promise((resolve) => {
			imagesLoaded(document.querySelectorAll(selector), { background: true }, resolve)
		})
	}

	// Returns an array of transform strings to evenly space carousel cells in 3D
	const getCarouselCellTransforms = (count, radius) => {
		const angleStep = 360 / count // Divide 360° by number of cells to get angle step
		return Array.from({ length: count }, (_, i) => {
			const angle = i * angleStep
			return `rotateY(${angle}deg) translateZ(${radius}rem)` // 3D rotation + translation
		})
	}

	// Applies 3D transforms to each cell in a given carousel
	const setupCarouselCells = (carousel) => {
		const wrapper = carousel.closest('.scene')
		const radius = parseFloat(wrapper.dataset.radius) || 500 // Read radius from data attribute or default to 500
		const cells = carousel.querySelectorAll('.carousel__cell')

		const transforms = getCarouselCellTransforms(cells.length, radius) // Get transform strings
		cells.forEach((cell, i) => {
			cell.style.transform = transforms[i] // Apply transform to each cell
		})
	}

	// Creates a scroll-linked GSAP timeline for a given carousel scene
	const createScrollAnimation = (carousel) => {
		// Create scroll-driven timeline
		carousel._timeline = gsap.timeline({
			defaults: { ease: 'sine.inOut' },
			scrollTrigger: {
				trigger: '.products',
				start: 'center center', // Start when top of wrapper hits bottom of viewport
				end: 'bottom+=100% top', // End when bottom of wrapper hits top of viewport
				scrub: true, // Smooth animation based on scroll position
				pin: true, // Pin the scene in place during the scroll
			},
		})

		carousel._timeline
			.fromTo(carousel, { rotationY: 0 }, { rotationY: -240 }, 0)
			.fromTo(carousel, { translateX: 0 }, { translateX: '100rem' }, '<') // Rotate carousel horizontally

		return carousel._timeline
	}

	// Initializes all carousels on the page
	const initCarousels = () => {
		document.querySelectorAll('.carousel').forEach((carousel) => {
			setupCarouselCells(carousel) // Position carousel cells in 3D
			carousel._timeline = createScrollAnimation(carousel) // Attach scroll animation timeline
		})
	}

	const init = () => {
		gsap.set('.products__container', {
			scale: 0.5,
			translateY: '100%',
		})

		gsap.to('.products__container', {
			scale: 1,
			translateY: '0%',
			scrollTrigger: {
				trigger: '.products',
				start: 'center-=800rem center',
				end: 'center top',
				scrub: true,
			},
		})

		initCarousels()
		window.addEventListener('resize', ScrollTrigger.refresh)
	}

	// Start app once images are preloaded
	preloadImages('.product').then(() => {
		init()
	})
}

if (mobile) {
	window.addEventListener('load', () => {
		ScrollTrigger.normalizeScroll({
			allowNestedScroll: true,
			type: 'touch,wheel,pointer',
		})

		gsap
			.timeline({
				defaults: { ease: 'power4.in' },
				scrollTrigger: {
					trigger: '.products',
					start: 'center center',
					end: 'bottom+=200% top',
					scrub: true,
					pin: true,
				},
			})
			.to(
				'.product-2',
				{
					transform: 'translateY(0)',
				},
				0
			)
			.to(
				'.product-1',
				{
					transform: 'translateY(-150%)',
				},
				'<'
			)
			.to(
				'.product-3',
				{
					transform: 'translateY(0)',
				},
				'>'
			)
			.to(
				'.product-2',
				{
					transform: 'translateY(-150%)',
				},
				'<'
			)
			.to(
				'.product',
				{
					delay: 0,
				},
				'>'
			)
	})
}
